import gameImage from "../Images/fact-or-fake.png";

export const minigameTool = {
  id: "fact-or-fake",
  attributes: {
    name_en: "Fact or Fake · Mini Game",
    name_th: "ข่าวจริง–ข่าวปลอม · มินิเกม",
  },
};

export function toolImage(member) {
  if (member.id === minigameTool.id) return gameImage;
  return "https://nx.kmutt.ac.th" +
    member.attributes.uploadfiles.data[0]?.attributes.fileupload.data[0]?.attributes.url;
}
